
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/footerItems/policies/privacyPolicy",
      function () {
        return require("private-next-pages/footerItems/policies/privacyPolicy.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/footerItems/policies/privacyPolicy"])
      });
    }
  